import { render, staticRenderFns } from "./CustomSeparator.vue?vue&type=template&id=36e04aab&scoped=true"
import script from "./CustomSeparator.vue?vue&type=script&lang=js"
export * from "./CustomSeparator.vue?vue&type=script&lang=js"
import style0 from "./CustomSeparator.vue?vue&type=style&index=0&id=36e04aab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e04aab",
  null
  
)

export default component.exports